
export enum ExtractorStartRuleType {
    startsWith = 0,
    startsAfter = 1,
    beginning = 2,
    ending = 3,
    justCopy = 4,
    lengthBetween = 5
}

export enum ExtractorEndRuleType {
    endsWith = 0,
    endsBefore = 1,
    endsAtEnd = 2,
    length = 3,
    ending = 4,
    findPhrases = 5
}